import { render, staticRenderFns } from "./noAccess.vue?vue&type=template&id=40d8f036&scoped=true"
import script from "./noAccess.vue?vue&type=script&lang=js"
export * from "./noAccess.vue?vue&type=script&lang=js"
import style0 from "./noAccess.vue?vue&type=style&index=0&id=40d8f036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8f036",
  null
  
)

export default component.exports